import React from 'react';
import { Alert } from '@mui/material';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';

// 미구현(스텁) 화면 - KSM에도 동일하게 미구현 상태라 bito에서 새로 생긴 버그는 아니다
// (2026-10-20 전체 화면 점검). 제목만 있던 빈 화면 대신 "준비 중"임을 명확히 알린다 -
// 기능 신규 개발 여부는 결정 대기(사용자 판단 보류).
const ForecastResultsPage = () => {
  return (
    <>
      <BreadcrumbsContainer title="분석·KPI/예상 실적" icon="statistics" />
      <Alert severity="info" sx={{ m: 2 }}>
        예상 실적 화면은 아직 준비 중입니다.
      </Alert>
    </>
  );
};

export default ForecastResultsPage;
